import { loadStripe } from "@stripe/stripe-js";

export class ProductType {
  static CREDITS = "credits";
  static LRAR = "lrar";
  static ABONNEMENT = "abonnement";
  static COMPTA = "compta";
}

export class IntentType {
  static PAYMENT = "payment";
  static SETUP = "setup";
}

export class PaymentMethodType {
  static CARD = "card";
  static SEPA_DEBIT = "sepa_debit";
}

export const STRIPE_LOAD_ERROR_MESSAGE =
  "Le module de paiement n'a pas pu être chargé. Si vous utilisez un bloqueur de publicités, désactivez-le pour cette page puis réessayez.";

// Chargé à la demande (et pas au boot de l'app) : les bloqueurs de publicités
// bloquent souvent js.stripe.com, inutile de le charger hors des pages de paiement.
let stripePromise = null;

export function getStripe() {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY).catch(
      (err) => {
        stripePromise = null;
        throw err;
      },
    );
  }
  return stripePromise;
}
